import Const from 'constants';

let TeamsCombinations = {
    setExposureMaxOfTeamCombinations(params) {
        return {
            type: Const.SET_EXPOSURE_MAX_OF_TEAM_COMBINATIONS,
            params,
        };
    },
};

export default TeamsCombinations;
